import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import onClickOutside from 'react-onclickoutside';
import SearchBarContext from './SearchBarContext';
import magnifyIcon from 'assets/magnify.svg';

class SearchBar extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    children: PropTypes.node,
    onMagnifyIconClick: PropTypes.func,
    onKeyDown: PropTypes.func,
  };

  static defaultProps = {
    className: "",
    style: {},
    value: "",
    placeholder: "",
    onChange: () => {},
    children: null,
    onMagnifyIconClick: () => {},
    onKeyDown: () => {},
  };

  state = { isOpen: false };

  handleClose = () => this.setState({ isOpen: false });

  render() {
    const {
      id,
      className,
      style,
      placeholder,
      value,
      children,
      onChange,
      onMagnifyIconClick,
      onKeyDown,
    } = this.props;
    const { isOpen } = this.state;
    return (
      <div id={id} className={className} style={style}>
        <div
          id={`${id}-container`}
          className={classnames('flex border border-gray-400 rounded-sm', {
            'rounded-b-none': isOpen
          })}
        >
          <input
            id={`${id}-input`}
            className="px-4 py-3 bg-transparent outline-none flex-1"
            placeholder={placeholder}
            value={value}
            onChange={e => {
              e.preventDefault();
              if (children) this.setState({ isOpen: true });
              onChange({ id, value: e.target.value });
            }}
            onKeyDown={onKeyDown}
          />
          <button
            className="bg-transparent border-gray-300 border-l flex items-center p-2 outline-none focus:outline-none"
            onClick={onMagnifyIconClick}
          >
            <img
              alt="search"
              src={magnifyIcon}
              key="Search icon"
              style={{ height: 24, width: 24 }}
            />
          </button>
        </div>
        {isOpen && (
          <SearchBarContext.Provider value={{ onClose: this.handleClose }}>
            {React.cloneElement(children, {
              style: { width: style.width }
            })}
          </SearchBarContext.Provider>
        )}
      </div>
    );
  }
}

const clickOutsideConfig = {
  handleClickOutside: instance => instance.handleClose
};

export default onClickOutside(SearchBar, clickOutsideConfig);
